// extracted by mini-css-extract-plugin
export default {"toast":"sGMA","notification":"YMGk","slide-in-right":"MhgZ","slideInRight":"MhgZ","slide-out-right":"B0e5","slideOutRight":"B0e5","beat":"tE9f"};